/* global modForm Modalytics */
export function addSiteLabelToHeap() {
	if (modForm.opts.isBestCompany) {
		return;
	}

	let siteLabel = null;

	if (modForm.opts.isBranded && !modForm.opts.isLeadForm) {
		siteLabel = 'Branded';
	} else if (modForm.opts.isModernize) {
		siteLabel = 'Modernize';
	} else if (modForm.opts.isCallOnly) {
		siteLabel = 'Non-Branded_Call-Only';
	} else {
		siteLabel = 'Non-Branded';
	}

	if (siteLabel) {
		const properties = {
			siteLabel: siteLabel
		};

		Modalytics.heap('addEventProperties', properties);
		Modalytics.heap('addUserProperties', properties);
	}
}
